import { Children, isValidElement, cloneElement } from 'react';
import styled from 'styled-components';

import type { Props as TabsPanelProps } from './TabsPanel';

type Props = {
  readonly activeId?: number;
  readonly children: JSX.Element | JSX.Element[];
};
const TabsBodyWrapper = styled.div`
  outline: none;
`;

const TabsBody = ({ activeId, children }: Props): JSX.Element => {
  if (activeId == null && __DEV__) {
    console.warn('<TabsBody> has to be instatiated inside <Tabs> component');
    return null;
  }

  const modifiedChildren = Children.map(children, (child, key) => {
    return isValidElement(child)
      ? cloneElement<Omit<TabsPanelProps, 'children'>>(child, {
          active: activeId === key,
        })
      : null;
  });
  // Should be focusable to help assistive technologies
  return <TabsBodyWrapper tabIndex={0}>{modifiedChildren}</TabsBodyWrapper>;
};

export default TabsBody;
